<template>
  <div class="my-3" v-if="medicamentosList.length > 0">

    <h6 class="col my-1 text-center">
      <strong>Tabla de Receta</strong>
    </h6>

    <b-row>

      <b-col>
        <b-table 
          :items="medicamentosList" 
          :fields="tableFields"
          class="text-center"
          responsive small
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>

          <template #cell(medicamento)="data">
            {{ data.item.medicamento }}
          </template>
          <template #cell(acciones)="data">
            <!-- <b-button
              variant="primary"
              size="sm"
              style="cursor: pointer"
              @click="onEditMedicamento(data.item)"
            >
              <font-awesome-icon
                icon="user-pen"
                style="color: rgb(253, 253, 253)"
              />
            </b-button> -->

            <b-button
              variant="danger"
              size="sm"
              style="cursor: pointer"
              @click="removeItem(data.item.id)"
            >
              <font-awesome-icon
                icon="circle-xmark"
                style="color: rgb(255, 255, 255)"
              />
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>

  </div>
</template>

<script>

export default {
  name: "RecetaTable",

  props: {
    medicamentosList: {
      type: Array,
      default: () => []
    },

    onlyView: {
      type: Boolean,
      default: false
    }
  },


  data() {
    return {
      
    }
  },

  methods: {

    removeItem(id){

    }
  },

  computed: {

    tableFields(){
      const baseFields = [
        { 
          key: "index", 
          label: "N°", 
          thClass: "text-center", 
          tdClass: "text-center" 
        },
        { key: "medicamento.nombre", label: "Medicamento", thClass: "text-center" },
        { key: "cantidad",    label: "Cantidad",    thClass: "text-center" },
        { key: "dosis",       label: "Dosis",       thClass: "text-center" },
        { key: "frecuencia",  label: "Frecuencia",  thClass: "text-center" },
        { key: "duracion",    label: "Duracion",    thClass: "text-center" },
        { key: "medicamento.presentacion",         label: "Via",         thClass: "text-center" },
        { key: "observacion", label: "Observación", thClass: "text-center" },
      ];


      if (this.onlyView) return baseFields;

      return [
        ...baseFields, 
        {
          key     : "acciones",
          label   : "acciones",
          sortable: true,
          thClass : "text-center",
          tdClass : "text-right",
        }
      ];
    }
  }
}
</script>
